import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess3057VzEintragenStatus: 'idle',
    startProcess3057VzEintragenError: undefined as any,
    loadUserParamsProcess3057VzEintragenStatus: 'idle',
    loadUserParamsProcess3057VzEintragenError: undefined as any,

    process3057VzEintragenList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess3057VzEintragen = createAsyncThunk('process3057VzEintragenSlice/startProcess3057VzEintragen', async ({ process3057VzEintragen }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess3057VzEintragen/`,
        prepareData(process3057VzEintragen),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess3057VzEintragenStatus } = getState().process3057VzEintragenSlice
        return startProcess3057VzEintragenStatus !== 'pending'
    }
})

export const loadUserParamsProcess3057VzEintragen = createAsyncThunk('process3057VzEintragenSlice/loadUserParamsProcess3057VzEintragen', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess3057VzEintragen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess3057VzEintragenStatus } = getState().process3057VzEintragenSlice
        return loadUserParamsProcess3057VzEintragenStatus !== 'pending'
    }
})

const Process3057VzEintragenSlice = createSlice({
    name: 'process3057VzEintragenSlice',
    initialState,
    reducers: {
        resetstartProcess3057VzEintragen: (state) => {
            state.job = undefined
            state.startProcess3057VzEintragenError = undefined
        },
        resetstartProcess3057VzEintragenError: (state) => {
            state.startProcess3057VzEintragenError = undefined
        },
        resetloadUserParamsProcess3057VzEintragen: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess3057VzEintragenError = undefined
        },
        resetloadUserParamsProcess3057VzEintragenError: (state) => {
            state.loadUserParamsProcess3057VzEintragenError = undefined
        },
        removeFromProcess3057VzEintragenListById: (state, action) => {
            state.process3057VzEintragenList = state.process3057VzEintragenList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess3057VzEintragenListByIds: (state, action) => {
            state.process3057VzEintragenList = state.process3057VzEintragenList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process3057VzEintragenList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess3057VzEintragenStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process3057VzEintragenList = []
            state.startProcess3057VzEintragenStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess3057VzEintragen.pending, (state) => {
            state.startProcess3057VzEintragenStatus = 'pending'
            state.startProcess3057VzEintragenError = undefined
        })
        builder.addCase(startProcess3057VzEintragen.fulfilled, (state, action) => {
            state.startProcess3057VzEintragenStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess3057VzEintragen.rejected, (state, action) => {
            state.startProcess3057VzEintragenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess3057VzEintragenError = action.error.message
            } else {
                state.startProcess3057VzEintragenError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess3057VzEintragen.pending, (state) => {
            state.loadUserParamsProcess3057VzEintragenStatus = 'pending'
            state.loadUserParamsProcess3057VzEintragenError = undefined
        })
        builder.addCase(loadUserParamsProcess3057VzEintragen.fulfilled, (state, action) => {
            state.loadUserParamsProcess3057VzEintragenStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess3057VzEintragen.rejected, (state, action) => {
            state.loadUserParamsProcess3057VzEintragenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess3057VzEintragenError = action.error.message
            } else {
                state.loadUserParamsProcess3057VzEintragenError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess3057VzEintragen,
    resetstartProcess3057VzEintragenError,
    resetloadUserParamsProcess3057VzEintragen,
    resetloadUserParamsProcess3057VzEintragenError,
    removeFromProcess3057VzEintragenListById,
    removeFromProcess3057VzEintragenListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process3057VzEintragenSlice.actions
export default Process3057VzEintragenSlice.reducer
